// import {
//   GET_DOCUMENT_TYPE_REQUEST,
//   GET_DOCUMENT_TYPE_SUCCESS,
//   GET_DOCUMENT_TYPE_FAILURE,
//   GET_DOCUMENT_TYPE_WITH_PAGINATION_REQUEST,
//   GET_DOCUMENT_TYPE_WITH_PAGINATION_SUCCESS,
//   GET_DOCUMENT_TYPE_WITH_PAGINATION_FAILURE,
// } from "./documentTypeTypes";
import {
  GET_DPPIDS_FAILURE,
  GET_DPPIDS_REQUEST,
  GET_DPPIDS_SUCCESS,
  GET_FG_OPERATION_FAILURE,
  GET_FG_OPERATION_REQUEST,
  GET_FG_OPERATION_SUCCESS,
  GET_INDUSTRY_TYPE_FAILURE,
  GET_INDUSTRY_TYPE_REQUEST,
  GET_INDUSTRY_TYPE_SUCCESS,
  GET_PASSPORT_DPPCODE_FAILURE,
  GET_PASSPORT_DPPCODE_REQUEST,
  GET_PASSPORT_DPPCODE_SUCCESS,
  GET_PASSPORT_FAILURE,
  GET_PASSPORT_REQUEST,
  GET_PASSPORT_SUCCESS,
  GET_RM_TRACE_FAILURE,
  GET_RM_TRACE_REQUEST,
  GET_RM_TRACE_SUCCESS,
  GET_SUPPLIER_ID_FAILURE,
  GET_SUPPLIER_ID_REQUEST,
  GET_SUPPLIER_ID_SUCCESS,
  GET_USERS_FOR_PRODUCTION_FAILURE,
  GET_USERS_FOR_PRODUCTION_REQUEST,
  GET_USERS_FOR_PRODUCTION_SUCCESS,
  GET_PRODUCT_SPECIFICATION_FAILURE,
GET_PRODUCT_SPECIFICATION_REQUEST,
GET_PRODUCT_SPECIFICATION_SUCCESS,
} from "./passPortTypes";

const initialState = {
  loading: false,
  passPort: [],
  error: "",
};

const getPassPortReducer = (state = initialState, action) => {
  switch (action.type) {
    case GET_PASSPORT_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PASSPORT_SUCCESS:
      return {
        loading: false,
        passPort: action.payload,
        error: "",
      };
    case GET_PASSPORT_FAILURE:
      return {
        loading: false,
        passPort: [],
        error: action.payload,
      };
    default:
      return state;
  }
};
const initialStateS = {
  loading: false,
  passPort: [],
  error: "",
};

const getPassPortViewReducer = (state = initialStateS, action) => {
  switch (action.type) {
    case GET_PASSPORT_DPPCODE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_PASSPORT_DPPCODE_SUCCESS:
      return {
        loading: false,
        passPort: action.payload,
        error: "",
      };
    case GET_PASSPORT_DPPCODE_FAILURE:
      return {
        loading: false,
        passPort: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateD = {
  loading: false,
  dpp: [],
  error: "",
};

const getDPPReducer = (state = initialStateD, action) => {
  switch (action.type) {
    case GET_DPPIDS_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_DPPIDS_SUCCESS:
      return {
        loading: false,
        dpp: action.payload,
        error: "",
      };
    case GET_DPPIDS_FAILURE:
      return {
        loading: false,
        dpp: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateDS = {
  loading: false,
  dpp: [],
  error: "",
};

const getIndustryTypeReducer = (state = initialStateDS, action) => {
  switch (action.type) {
    case GET_INDUSTRY_TYPE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_INDUSTRY_TYPE_SUCCESS:
      return {
        loading: false,
        dpp: action.payload,
        error: "",
      };
    case GET_INDUSTRY_TYPE_FAILURE:
      return {
        loading: false,
        dpp: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateDSs = {
  loading: false,
  dpp: [],
  error: "",
};

const getSupplierTypeReducer = (state = initialStateDSs, action) => {
  switch (action.type) {
    case GET_SUPPLIER_ID_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_SUPPLIER_ID_SUCCESS:
      return {
        loading: false,
        dpp: action.payload,
        error: "",
      };
    case GET_SUPPLIER_ID_FAILURE:
      return {
        loading: false,
        dpp: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateF = {
  loading: false,
  rmTrace: [],
  error: "",
};

const getRmTraceReducer = (state = initialStateF, action) => {
  switch (action.type) {
    case GET_RM_TRACE_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_RM_TRACE_SUCCESS:
      return {
        loading: false,
        rmTrace: action.payload,
        error: "",
      };
    case GET_RM_TRACE_FAILURE:
      return {
        loading: false,
        rmTrace: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateg = {
  loading: false,
  fgOperation: [],
  error: "",
};

const getFgOperationReducer = (state = initialStateg, action) => {
  switch (action.type) {
    case GET_FG_OPERATION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_FG_OPERATION_SUCCESS:
      return {
        loading: false,
        fgOperation: action.payload,
        error: "",
      };
    case GET_FG_OPERATION_FAILURE:
      return {
        loading: false,
        fgOperation: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStatef = {
  loading: false,
  users: [],
  error: "",
};

const getUsersForFGReducer = (state = initialStatef, action) => {
  switch (action.type) {
    case GET_USERS_FOR_PRODUCTION_REQUEST:
      return {
        ...state,
        loading: true,
      };
    case GET_USERS_FOR_PRODUCTION_SUCCESS:
      return {
        loading: false,
        users: action.payload,
        error: "",
      };
    case GET_USERS_FOR_PRODUCTION_FAILURE:
      return {
        loading: false,
        users: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

// const initialStateWithPagination = {
//   loading: false,
//   documentType: [],
//   error: "",
// };

// const getDocumentTypeWithPaginationReducer = (
//   state = initialStateWithPagination,
//   action
// ) => {
//   switch (action.type) {
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_REQUEST:
//       return {
//         ...state,
//         loading: true,
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_SUCCESS:
//       return {
//         loading: false,
//         documentType: action.payload,
//         error: "",
//       };
//     case GET_DOCUMENT_TYPE_WITH_PAGINATION_FAILURE:
//       return {
//         loading: false,
//         documentType: [],
//         error: action.payload,
//       };
//     default:
//       return state;
//   }
// };

const initialStateM = {
  loading: false,
  manufacturerDetails: [],
  error: "",
};

const getManufacturerDetailsReducer = (state = initialStateM, action) => {
  switch (action.type) {
    case "GET_MANUFACTURER_DETAILS_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_MANUFACTURER_DETAILS_SUCCESS":
      return {
        loading: false,
        manufacturerDetails: action.payload,
        error: "",
      };
    case "GET_MANUFACTURER_DETAILS_FAILURE":
      return {
        loading: false,
        manufacturerDetails: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStatePV = {
  loading: false,
  productVariant: [],
  error: "",
};

const getProductVariantReducer = (state = initialStatePV, action) => {
  switch (action.type) {
    case "GET_PRODUCT_VARIANT_REQUEST":
      return {
        ...state,
        loading: true,
      };
    case "GET_PRODUCT_VARIANT_SUCCESS":
      return {
        loading: false,
        productVariant: action.payload,
        error: "",
      };
    case "GET_PRODUCT_VARIANT_FAILURE":
      return {
        loading: false,
        productVariant: [],
        error: action.payload,
      };
    default:
      return state;
  }
};

const initialStateProductSpec = {
  loading: false,
  productSpecification: [],
  error: "",
};

const getProductSpecificationReducer = (
  state = initialStateProductSpec,
  action
) => {
  switch (action.type) {
    case GET_PRODUCT_SPECIFICATION_REQUEST:
      return {
        ...state,
        loading: true,
      };

    case GET_PRODUCT_SPECIFICATION_SUCCESS:
      return {
        loading: false,
        productSpecification: action.payload,
        error: "",
      };

    case GET_PRODUCT_SPECIFICATION_FAILURE:
      return {
        loading: false,
        productSpecification: [],
        error: action.payload,
      };

    default:
      return state;
  }
};

export {
  getPassPortReducer,
  getRmTraceReducer,
  // getRmTraceReducer,
  getDPPReducer,
  getFgOperationReducer,
  getUsersForFGReducer,
  getPassPortViewReducer,
  getProductVariantReducer,
  getManufacturerDetailsReducer,
  getIndustryTypeReducer,
  getSupplierTypeReducer,
  getProductSpecificationReducer,
  //  getDocumentTypeWithPaginationReducer
};
